{
    "order_detail": {
        "back": "Back",
        "printOrder": "Print order",
        "orderTitle": "Order",
        "newBadge": "NEW",
        "billingAddress": "Billing address",
        "shippingAddress": "Shipping address",
        "notes": "Notes",
        "requestedDeliveryDate": "Requested delivery date",
        "firstAvailableDate": "First available date",
        "paymentMethod": "Payment Method",
        "itemsSummary": "Items summary",
        "unitPrice": "Unit price",
        "orderSummary": "Order summary",
        "items": "items",
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "vat": "VAT",
        "total": "Total",
        "customer_ref": "Customer reference"
    },
    "invoice_detail": {
        "back": "Back",
        "printInvoice": "Print invoice",
        "invoiceTitle": "Invoice",
        "newBadge": "NEW",
        "billingAddress": "Billing address",
        "shippingAddress": "Shipping address",
        "orderNumber": "Order Number",
        "paymentMethod": "Payment Method",
        "itemsSummary": "Items summary",
        "unitPrice": "Unit price",
        "invoiceSummary": "Invoice summary",
        "items": "items",
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "vat": "VAT",
        "total": "Total"
    },
    "ddt_detail": {
        "back": "Back",
        "printDdt": "Print delivery note",
        "ddtTitle": "Delivery Note",
        "newBadge": "NEW",
        "billingAddress": "Billing address",
        "shippingAddress": "Shipping address",
        "orderNumber": "Order Number",
        "paymentTerm": "Payment terms",
        "dueDate": "Due date",
        "invoiceDate": "Invoice date",
        "postingDate": "Posting date",
        "itemsSummary": "Items summary",
        "quantity": "Quantity: ",
        "shipmentDate": "Shipment date: ",
        "ddtSummary": "Delivery Note Summary",
        "items": "items"
    },
    "credit_note_detail": {
        "back": "Back",
        "printCreditNote": "Print credit note",
        "creditNoteTitle": "Credit Note",
        "newBadge": "NEW",
        "billingAddress": "Billing address",
        "sellingAddress": "Selling address",
        "invoiceNumber": "Invoice Number",
        "itemsSummary": "Items summary",
        "unitPrice": "Unit price",
        "creditNoteSummary": "Credit note summary",
        "items": "items",
        "subtotal": "Subtotal",
        "total": "Total"
    },
    "account_area": {
        "orders": {
            "no_orders": "There are no orders.",
            "table": {
                "order_number": "Order No.",
                "date": "Date",
                "order_status": "Status",
                "shipping_date": "Shipping date",
                "total_price": "Total"
            }
        },
        "invoices": {
            "no_invoices": "There are no invoices.",
            "no_invoice": "There are no invoices.",
            "table": {
                "invoice_number": "Invoice No.",
                "date": "Date",
                "description": "Description",
                "tax": "Tax",
                "total": "Total",
                "status": "Status",
                "order_number": "Order No.",
                "amount_excluding_tax": "Amount excl. VAT",
                "amount_including_tax": "Amount incl. VAT"
            }
        },
        "ddts": {
            "no_ddts": "There are no delivery notes.",
            "no_ddt": "There are no delivery notes.",
            "table": {
                "ddt_number": "Delivery Note No.",
                "invoice_date": "Invoice date",
                "posting_date": "Posting date",
                "due_date": "Due date",
                "order_number": "Order No.",
                "payment_term": "Payment terms"
            }
        },
        "credit_notes": {
            "no_credit_notes": "There are no credit notes.",
            "no_credit_note": "There are no credit notes.",
            "table": {
                "credit_note_number": "Credit Note No.",
                "date": "Date",
                "status": "Status",
                "invoice_number": "Invoice No.",
                "amount_excluding_tax": "Amount excl. VAT",
                "amount_including_tax": "Amount incl. VAT"
            }
        },
        "downloads": {
            "no_downloads": "There are no files.",
            "no_download": "There are no files.",
            "categories": {
                "title": "Download Area",
                "back": "← Back",
                "select_category": "Select a category"
            },
            "table": {
                "file_name": "File name",
                "date": "Date",
                "description": "Description"
            }
        }
    },
    "b2b_store": {
        "no_items": "No products available in the store.",
        "subtotal_label": "Total items",
        "total_label": "Total quantity",
        "go_to_checkout_label_btn": "Go to checkout"
    },
    "b2b_send_order": {
        "shipping_and_payment": "Shipping and payment",
        "billing_address": "Billing address",
        "payment_method": "Payment method",
        "shipping_address": "Shipping address",
        "items_summary": "Items summary",
        "product": "Product",
        "unit_price": "Unit price",
        "pieces_short": "pcs",
        "order_summary": "Order summary",
        "items": "items",
        "subtotal": "Subtotal",
        "vat": "VAT",
        "total": "Total",
        "requested_delivery": "Requested delivery",
        "first_available_date": "First available date",
        "exact_date": "Exact date",
        "exact_date_help": "Enter the date you would like your order to be delivered",
        "date_placeholder": "dd/mm/yyyy",
        "additional_info": "Additional information",
        "additional_info_help": "Enter your reference and/or an order note if necessary",
        "customer_reference_placeholder": "Customer reference",
        "order_note_placeholder": "Order note",
        "send_order": "Send order",
        "back_to_store": "← Back to B2B Store",
        "error_address": "WARNING: There are no shipping and/or billing addresses",
        "error_send_order": "There was an error sending the order"
    },
    "b2b_customer_data_checks": {
        "error_title": "Missing customer data",
        "error_message": "No customer data was found to proceed with the B2B order. Please make sure you are logged in as a B2B customer and that your profile contains at least one valid address."
    },
    "order_status": {
        "new": "New",
        "complete": "Shipped",
        "approved": "Approved",
        "New": "New",
        "Processing": "Proccessing",
        "Imported": "To Approve",
        "Error": "Error",
        "Blocked": "Blocked",
        "Canceled": "Canceled",
        "ToApprove": "To Approve",
        "Approved": "Approved",
        "Open": "Open",
        "Pending": "Approved"
    },
    "general": {
        "button_paginator_label": "Load more"
    },
    "rma_form": {
        "error_submit": "Error submitting RMA",
        "error_load_ddt": "Could not load delivery note data",
        "error_missing_data": "Missing data to complete the RMA",
        "vat_label": "VAT Number",
        "serial_number_label": "Serial Number",
        "reason_label": "Reason",
        "submit_button": "Submit Complaint",
        "error_load_row": "No row products found",
        "error_load_ddt_details": "Error loading DDT detail data"
    }
}
